import { createClient } from '@supabase/supabase-js';
var SUPABASE_URL = process.env.SUPABASE_URL;
var SUPABASE_ANON_KEY = process.env.SUPABASE_ANON_KEY;
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    throw new Error('Missing Supabase environment variables');
}
export var supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
